import {useConfirm} from '../components/ds/confirmContext.ts';
import {unsavedWork} from '../lib/unsavedWork.ts';

// Resolves true when it's fine to leave: nothing unsaved, or the person says
// to go anyway.
export default function useConfirmLeave(): () => Promise<boolean> {
    const confirm = useConfirm();

    return async () => {
        const message = unsavedWork();
        if (!message) {
            return true;
        }
        return confirm({
            title: 'Leave without saving?',
            body: message,
            confirmLabel: 'Leave without saving',
            safeLabel: 'Keep editing',
            danger: true
        });
    };
}
